import React, { useState } from 'react';
import { ContentsItem } from '../../../modules/editor/types';

// 에디트 모듈
import TextEdit from '../Edit/TextEdit';
import ImageEdit from '../Edit/ImageEdit';
import CtaEdit from '../Edit/CtaEdit';
import { useDispatch, useSelector } from 'react-redux';
import { setMarkedToolbar } from '../../../modules/editor';
import { RootState } from '../../../modules';

type Props = {
	contentItem: ContentsItem
};

function Header({ contentItem }: Props) {

	const dispatch = useDispatch();
	
	const markedToolbar = useSelector((state: RootState) => state.editor.markedToolbar);

	const markToolbar = (contentId: number, currentIndex: number, itemType:string) => {
		dispatch(setMarkedToolbar({
			contentId: contentId,
			currentIndex: currentIndex,
			itemType: itemType
		}))
	}

	return (
		<>
			{
				contentItem.content.column.map((column: string[], index: number) => (
					<div
						key={index}
						className={`content-column column-index-${index}`}
						style={{
							paddingLeft: contentItem.content.style[0].column?.paddingLeft,
							paddingRight: contentItem.content.style[0].column?.paddingRight
						}}
					>
						{
							column.map((row: string, subIndex: number) => (
								<div
									key={subIndex}
								>
									{row === 'text' && (
										<TextEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].text}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
									{row === 'cta' && (
										<CtaEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].button}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
									{row === 'image' && (
										<ImageEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].image}
											columnCount={contentItem.content.column.length}
											editing={contentItem.content.editing}
										/>
									)}
								</div>
							))
						}
					</div>
				))
			}
		</>
	)
}

export default Header;